module.exports = __webpack_public_path__ + "img/slide7.webp";